import { Outlet } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import CartDrawer from "@/components/feature/CartDrawer";
import { useSiteSettings } from "@/hooks/useApi";

export default function Layout() {
  const { data: settings } = useSiteSettings();
  const whatsapp =
    settings?.contact_info?.whatsapp?.replace(/\D/g, "") || "972590000000";

  return (
    <>
      <Header />
      <CartDrawer />
      <Outlet />
      <Footer />
      <a
        href="https://waze.com/ul/hsvc44gk4t"
        target="_blank"
        rel="nofollow noopener noreferrer"
        className="fixed bottom-24 right-6 z-50 w-14 h-14 bg-[#05C8F7] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
        aria-label="فتح الموقع عبر Waze"
      >
        <svg
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          className="w-8 h-8 fill-white"
        >
          <path d="M13.218 0C9.915 0 6.835 1.49 4.723 4.148c-1.515 1.913-2.31 4.272-2.31 6.706v1.739c0 .894-.62 1.738-1.862 1.813-.298.025-.547.224-.547.522-.05.82.82 2.31 2.012 3.502.82.844 1.788 1.515 2.832 2.036a3 3 0 0 0 2.955 3.528 2.966 2.966 0 0 0 2.931-2.385h2.509c.323 1.689 2.086 2.856 3.974 2.21 1.64-.546 2.36-2.409 1.763-3.924a12.84 12.84 0 0 0 1.838-1.465 10.73 10.73 0 0 0 3.18-7.65c0-2.882-1.118-5.589-3.155-7.625A10.899 10.899 0 0 0 13.218 0zm0 1.217c2.558 0 4.967.994 6.78 2.807a9.525 9.525 0 0 1 2.807 6.78A9.526 9.526 0 0 1 20 17.585a9.647 9.647 0 0 1-6.78 2.807h-2.46a3.008 3.008 0 0 0-2.93-2.41 3.03 3.03 0 0 0-2.534 1.367v.024a8.945 8.945 0 0 1-2.41-1.788c-.844-.844-1.316-1.614-1.515-2.11a2.858 2.858 0 0 0 1.441-.846 2.959 2.959 0 0 0 .795-2.036v-1.789c0-2.11.696-4.197 2.012-5.861 1.863-2.385 4.62-3.726 7.6-3.726zm-2.41 5.986a1.192 1.192 0 1 0 0 2.385 1.192 1.192 0 0 0 0-2.385zm7.204 0a1.192 1.192 0 1 0 0 2.385 1.192 1.192 0 0 0 0-2.385zm-7.377 4.769a.596.596 0 0 0-.546.845 4.813 4.813 0 0 0 4.346 2.757 4.77 4.77 0 0 0 4.347-2.757.596.596 0 0 0-.547-.845h-.025a.561.561 0 0 0-.521.348 3.59 3.59 0 0 1-3.254 2.061 3.591 3.591 0 0 1-3.254-2.061.64.64 0 0 0-.546-.348z" />
        </svg>
      </a>
      {whatsapp && (
        <a
          href={`https://wa.me/${whatsapp}`}
          target="_blank"
          rel="noopener noreferrer"
          className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-green-500 rounded-full flex items-center justify-center shadow-lg hover:bg-green-600 transition-colors"
          aria-label="تواصل معنا عبر واتساب"
        >
          <i className="ri-whatsapp-line text-2xl text-white" />
        </a>
      )}
    </>
  );
}
